import { PhoneNumberUtil } from "google-libphonenumber";

export const getPhoneNumberLengthByCountryCode = (countryCode: string) => {
    const phoneUtil = PhoneNumberUtil.getInstance();
    return phoneUtil
        .getExampleNumberForType(countryCode, 1)
        .getNationalNumber()
        ?.toString().length || 0
}